@let currentCountryCode = countryFormControl().value.toLowerCase();
<mat-form-field>
  <mat-label class="text-sm font-medium">Teléfono</mat-label>
  <input
    #phoneInput
    matInput
    [formControl]="phoneFormControl()"
    placeholder="Inserte el número de teléfono"
    type="tel" />
  @if (phoneFormControl().hasError('required')) {
    <mat-error>El teléfono es requerido</mat-error>
  } @else if (phoneFormControl().hasError('pattern')) {
    <mat-error>El teléfono no es válido</mat-error>
  }
  <mat-select
    matPrefix
    class="!flex items-center"
    [disabled]="countryFormControl().disabled"
    (openedChange)="onSelectCountryOpenedChange($event)">
    <mat-select-trigger>
      <div class="flex flex-row items-center space-x-2 mx-2">
        <mat-icon [svgIcon]="currentCountryCode"></mat-icon>
        <span class="opacity-70">{{ dialCode() }}</span>
      </div>
    </mat-select-trigger>
    @for (country of filteredCountries(); track country.iso_2) {
      <mat-option [value]="country.iso_2">
        <mat-icon [svgIcon]="country.iso_2.toLowerCase()"></mat-icon>
        {{ country.iso_2 | countryName: 'es' }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>
